/** Overlay image + alt for video “Watch now” CTA — one asset URL per newsletter language. */

const DEFAULT_LANG = 'en'

function pick<T>(map: Record<string, T>, language?: string | null): T {
  if (!language) return map[DEFAULT_LANG]
  return map[language] ?? map[DEFAULT_LANG]
}

/** Replace per-locale URLs when localized assets are ready (same key order as CTA / translations). */
export const VIDEO_WATCH_NOW_IMAGE_BY_LANGUAGE: Record<string, string> = {
  en: 'https://assets.bwbx.io/images/users/iqjWHBFdfxIU/iuquhjMLDeIY/v0/-1x-1.png',
  ja: 'https://assets.bwbx.io/images/users/iqjWHBFdfxIU/i6Iosce8FlJA/v0/-1x-1.png',
  de: 'https://assets.bwbx.io/images/users/iqjWHBFdfxIU/iiiSnqNqi0Uk/v0/-1x-1.png',
  es: 'https://assets.bwbx.io/images/users/iqjWHBFdfxIU/ikh0FjbfDEuk/v0/-1x-1.png',
  pt: 'https://assets.bwbx.io/images/users/iqjWHBFdfxIU/iES4449gzFWI/v0/-1x-1.png',
  zh: 'https://assets.bwbx.io/images/users/iqjWHBFdfxIU/i0bcF.BmQEYY/v0/-1x-1.png',
  ko: 'https://assets.bwbx.io/images/users/iqjWHBFdfxIU/iK.1dvAsWgL4/v0/-1x-1.png',
}

export const VIDEO_WATCH_NOW_ALT_BY_LANGUAGE: Record<string, string> = {
  en: 'Watch now',
  ja: '今すぐ見る',
  de: 'Jetzt anschauen',
  es: 'Ver ahora',
  pt: 'Assista agora',
  zh: '立即观看',
  ko: '지금 바로 보기',
}

export function getVideoWatchNowImage(language?: string | null): string {
  return pick(VIDEO_WATCH_NOW_IMAGE_BY_LANGUAGE, language)
}

export function getVideoWatchNowAlt(language?: string | null): string {
  return pick(VIDEO_WATCH_NOW_ALT_BY_LANGUAGE, language)
}
